import { PlaylistIcon as PhosphorPlaylistIcon } from "@phosphor-icons/react/dist/ssr/Playlist";

import { createAppIcon } from "@/components/createAppIcon";

export const EmptyPlaylistIcon = /* @__PURE__ */ createAppIcon(PhosphorPlaylistIcon);
export const MusicQueueIcon = /* @__PURE__ */ createAppIcon(PhosphorPlaylistIcon);
